<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div v-if="!showPageLoader" class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div
                        v-for="(field, index) in fields"
                        :key="index"
                        :class="{
                            [field.class]: true,
                            'col-lg-12': field.type == 'heading',
                            'col-md-4':
                                field.type !== 'heading' && !field.class,
                            'col-md-8':
                                (index == 4 || index == 6) &&
                                section == 'account-info',
                        }"
                    >
                        <div
                            v-if="field.type == 'heading' && index > 0"
                            class="form-border"
                        ></div>

                        <component
                            :is="field.type"
                            :field="field"
                            :data-segment-id="dataSegmentId"
                        ></component>
                    </div>
                    <div class="col-lg-12"><div class="form-border"></div></div>
                </div>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="CONTINUE"
                    class="mr-3"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>
                <span v-if="loading" class="secondary-color">
                    Please wait. We're processing your request...</span
                >
            </div>
        </div>
        <!-- When data is loading -->
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import Nationality from '@/components/registration/Nationality.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            section: 'setup-profile',
            fields: [],
            showPageLoader: true,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters(['loading', 'dataSegmentId']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getRecords()
        // this.$refs.modaltest.show()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        validateAllCustom(formData) {
            // Issuance Date earlier than expiry date
            if (
                formData &&
                formData.identityInfo &&
                formData.identityInfo.IssuanceDate &&
                formData.identityInfo.expiryDate
            ) {
                return this.earlierDateValidator(
                    formData.identityInfo.IssuanceDate,
                    'Issuance Date',
                    formData.identityInfo.expiryDate,
                    'Expiry Date'
                )
            }
            // Age should be greater than 18
            // if (formData.basicInfo && formData.basicInfo.dateOfBirth) {
            //     let TODAY = new Date(Date.now())
            //     let EIGHTEEN_YEARS_BACK = new Date(
            //         new Date(TODAY).getDate() +
            //             '/' +
            //             new Date(TODAY).getMonth() +
            //             '/' +
            //             (new Date(TODAY).getFullYear() - 18)
            //     )
            //     let result =
            //         EIGHTEEN_YEARS_BACK > formData.basicInfo.dateOfBirth

            //     if (!result) {
            //         const index = this.fields.findIndex((field) => {
            //             if (field.label === 'Date of Birth') {
            //                 return true
            //             }
            //         })
            //         if (index) {
            //             this.fields[index]['isInvalid'] = true
            //         }
            //         return {
            //             valid: false,
            //             error: 'Age should be greater than 18',
            //         }
            //     }
            // }
        },
        // Comparision between Dates Validation
        earlierDateValidator(
            earlierDate,
            earlierDateLabel,
            lateDate,
            lateDateLabel
        ) {
            if (earlierDate > lateDate) {
                const index = this.fields.findIndex((field) => {
                    if (field.label === 'Issuance Date') {
                        return true
                    }
                })
                // console.log("INDEX : " + index)
                this.fields[index]['isInvalid'] = true
                return {
                    valid: false,
                    error:
                        earlierDateLabel +
                        ' should be earlier than ' +
                        lateDateLabel,
                }
            }
        },
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            this.$emit('close', true)
            // this.$refs.modaltest.hide()
            // console.log(this.fields)
            // validate the form fields
            // const result = await this.$validator.validateAll()

            // // Form State Data
            // const formData = this.$store.state.registration.form

            // const resultCustom = this.validateAllCustom(formData)

            // // Check if validation fails
            // if (result) {
            //     if (resultCustom && !resultCustom.valid) {
            //         this.$store.commit(
            //             'setError',
            //             resultCustom && resultCustom.error
            //                 ? resultCustom.error
            //                 : ''
            //         )
            //     } else {
            //         console.log(
            //             'States:' +
            //                 JSON.stringify(this.$store.state.registration.form)
            //         )
            //         this.$store.commit('setLoading', true)
            //         if (this.restrictDuplicateCustomers) {
            //             //check customer nic if already exists with their datasegment
            //             let error = false
            //             try {
            //                 const params = {}
            //                 params.dataSegmentId = this.dataSegmentId
            //                 params.number = this.$store.state.registration.form.identityInfo.number

            //                 const { data } = await request({
            //                     url: '/customers/exists',
            //                     method: 'get',
            //                     params,
            //                 })

            //                 console.log('Exits: ', data)
            //             } catch (e) {
            //                 error = e
            //             }

            //             if (error) {
            //                 this.$store.commit('setError', error)
            //                 this.$store.commit('setLoading', false)
            //                 return false
            //             }
            //         }

            //         if (this.$route.meta.publicRegistration === true) {
            //             this.$router.push({
            //                 name: 'public-registration-account-info',
            //                 params: {
            //                     dataSegmentId: this.dataSegmentId,
            //                 },
            //             })
            //         } else {
            //             this.$router.push('/register-customer/account-info')
            //         }
            //     }
            // } else {
            //     this.$store.commit('setError', this.errors.all()[0])
            // }
        }, // End of onSubmit() method

        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                    },
                })

                this.showPageLoader = false
                this.fields = data.data
                // this.getDraftCustomer()
                // console.log('Form Results: ' + JSON.stringify(data))
            } catch (error) {
                // console.log('Setup-Profile-error ' + error)
            }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
    }, // End of Component > watch
} // End of export default
</script>
